import { Component } from 'react'

import * as h from 'h'

import ResultBox from 'components/ResultBox'

import styles from './styles.scss'

export default class RelatedElements extends Component {
  render () {
    const { title, elements, small } = this.props

    if (!elements || elements.length === 0) {
      return null
    }

    return h.aside(h.ca(styles.relatedElements),
      h.h2(null, title),
      elements.map(element =>
        h.h(ResultBox, {
          key: element.id,
          element: element,
          small: small
        })))
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/Popout/RelatedElements.js